// extracted by mini-css-extract-plugin
export default {"trashableRichText":"Lh3LPir42RSS3pA832ZH","trashableRichTextIcon":"Qp65TFCjrnbEhwBrHcIi"};